import { useUserContext } from '../../../hooks/UserContext';
import { useCompany } from '../../../hooks/CompanyContext';
import { useQuery } from 'react-query';
import PremiseService from '../../../services/bioplus-services/premise';
import { MapComponent } from './map';

const getPremises = (userRole, companyFilter) => {
  switch (userRole.role) {
    case 'PARTNER': {
      return PremiseService.listAllByPartner(userRole?.partnerId, { companyId: companyFilter });
    }
    case 'ADMIN': {
      return PremiseService.getAllPremiseAsAdminExcel(companyFilter);
    }
    case 'OWNER': {
      return PremiseService.listAllByCompany(userRole.companyId?.id, {});
    }
    case 'EMPLOYEE': {
      return PremiseService.listAllByCompany(userRole.companyId?.id, {});
    }
    case 'VISITOR': {
      return PremiseService.listAllByCompany(userRole.companyId?.id, {});
    }
    default:
      return [];
  }
};

const getLastItem = (array) => array?.at?.(-1) || null;

const MapDependencies = ({
  markers,
  geofenceData,
  fetchData,
  stateData,
  geoFence,
  isView,
  navigate,
  isViewFriendLocation,
}) => {
  const userRole = useUserContext()?.company;
  const userContext = useUserContext();
  const companyFilter = useCompany()?.company?._id;
  const premiseQuery = useQuery(['premisesAll', userRole, companyFilter], () =>
    getPremises(userRole, companyFilter)
  );

  const isManger = userRole?.role === 'MANAGER';
  const isVisitor = userRole?.role === 'VISITOR';
  const managerPremise = geofenceData ? [geofenceData[0]?.premiseId] : [];

  const { userPermission } = userContext;
  const isUserAllowToManage = userPermission?.find(
    (permission) => permission?.label === 'geofence'
  );

  const canManageGeofence = !!isUserAllowToManage?.isManage;
  const canCreateGeofence = !!isUserAllowToManage?.isCreate;

  if (premiseQuery.isLoading) return <></>;

  return (
    <MapComponent
      markers={markers}
      geofenceData={geofenceData}
      premises={
        isManger
          ? managerPremise
          : isVisitor
          ? getLastItem(premiseQuery?.data)
          : premiseQuery.data ?? []
      }
      fetchData={() => fetchData()}
      stateData={stateData}
      geoFence={geoFence}
      isView={isView}
      navigate={navigate}
      isViewFriendLocation={isViewFriendLocation}
      canManageGeofence={canManageGeofence}
      canCreateGeofence={canCreateGeofence}
    />
  );
};

export default MapDependencies;
